import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { ActivityInternal, ActivityInternalFilter, ActivityInternalListConfigService, MetadataService } from 'gung-standard';
import { map, Observable } from 'rxjs';
import { ColmecActivityInternalTableComponent } from '../components/colmec-activity-internal-table/colmec-activity-internal-table.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecActivityInternalListConfigService extends ActivityInternalListConfigService {
  getFilters(): ConfigBaseFilter<ActivityInternal>[] {
    return [
      new ActivityInternalStatusMetaDataFilter('STATUS', 'status', this.metadataService),
      new ActivityInternalFilter('CUSTOMER_NAME', 'customerName'),
      new ActivityInternalFilter('CUSTOMER_RESPONSIBLE', 'customerResponsible'),
      new ActivityInternalTypeMetaDataFilter('ACTIVITY_TYPE', 'type', this.metadataService)
    ];
  }

  getLayouts(): ListLayout<ActivityInternal>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecActivityInternalTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getItems(): Observable<ActivityInternal[]> {
    return this.activityInternalService.getAll().pipe(
      map(result => {
        if (this.customerId) {
          return result.filter(r => r.customerId === this.customerId);
        }
        return result;
      }),
      map(result =>
        result.sort((a, b) => {
          console.log(result);
          if (parseInt(a.status, 10) < parseInt(b.status, 10)) {
            return -1;
          }
          if (parseInt(a.status, 10) > parseInt(b.status, 10)) {
            return 1;
          }
          if (new Date(a.date) > new Date(b.date)) {
            return -1;
          }
          if (new Date(a.date) < new Date(b.date)) {
            return 1;
          }
          return 0;
        })
      )
    );
  }
}

export class ActivityInternalStatusMetaDataFilter extends SimpleConfigBaseFilter<ActivityInternal> {
  constructor(private filterName: string, private filterKey: string, protected metadataService: MetadataService) {
    super();
  }

  getOptionIds(item: ActivityInternal): string[] {
    return [item[this.filterKey]];
  }
  getOptionName(key: string): string {
    console.log(key);
    return this.metadataService.getMetadataValue('ACTIVITYINTERNALSTATUS', 'name', key + '@ACTIVITYINTERNALSTATUS');
  }
  getName(): string {
    return this.filterName;
  }
}

export class ActivityInternalTypeMetaDataFilter extends SimpleConfigBaseFilter<ActivityInternal> {
  constructor(private filterName: string, private filterKey: string, protected metadataService: MetadataService) {
    super();
  }

  getOptionIds(item: ActivityInternal): string[] {
    return [item[this.filterKey]];
  }
  getOptionName(key: string): string {
    console.log(key);
    return this.metadataService.getMetadataValue('ACTIVITYINTERNALTYPE', 'name', key + '@ACTIVITYINTERNALTYPE');
  }
  getName(): string {
    return this.filterName;
  }
}
